<template>         
    <v-tab :href="uiid" @dblclick.native="editTabName" @click.stop.prevent="$store.myActions.FLEET_NAVTO_DETAIL({cmp:tab.cmp,isleft,id:tab.id})" :title="tabTooltip" >        
      <template v-if="edited">
        <drag :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}" class="drag">
          <v-text-field style="margin-top:14px" autofocus @keyup.esc="cancelEdit"  @keyup.enter="closeAndSave" label="Tab Name" v-model="tmpName"></v-text-field>
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="closeAndSave" :title="$t('Pilot.FleetInfos.SaveTooltip')">
          <v-icon small>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <drag class="drag" :transfer-data="{cmp:tab.cmp,isleft,id:tab.id}">{{ tryTranslate(tab.label) }}
          <v-spacer />
        </drag>
        <v-btn class="mr-0" small icon @click.prevent.stop="close" :title="$t('Pilot.FleetInfos.CloseDetailTabTooltip')">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-tab>  
</template>
<script lang="ts">
  import Vue from 'vue'
  import Component from 'vue-class-component'  
  import { UiTab } from '@/models/ui/UiTab';

  @Component({
    name: 'FleetDetailNavTab',
    props: {
      isleft:Boolean,               
      tab:{
        type:UiTab,
        required:true
      }
    }    
  })
  export default class FleetDetailNavTab extends Vue { 
    isleft!:boolean
    tab!:UiTab
    edited = false
    tmpName = ""
    mounted() {      
    }
    get uiid() {
      return `${this.tab.cmp}-${this.tab.id}`
    }
    get tabTooltip() {
      return this.edited?`${this.tab.label} - ${this.$t('Pilot.FleetInfos.EscToCancel')}`:
                    `${this.tab.label} - ${this.$t('Pilot.FleetInfos.DoubleClickToRename')}`
    }
    
    tryTranslate(key:string) {        
      const transKey = `Pilot.FleetDetailMenu.${key}`
      const trad = this.$t(transKey).toString()
      return transKey == trad?key:trad
    }

    close(){
      this.$store.myActions.FLEET_UNSELECT_TAB({cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft})        
    }
      
    editTabName() {
      this.tmpName = this.tryTranslate(this.tab.label)
      this.edited = true        
    }
      
    closeAndSave() {
      this.$store.myActions.FLEET_RENAME_DETAIL({cmp:this.tab.cmp,id:this.tab.id,isleft:this.isleft,label:this.tmpName})
      this.edited = false
    }

    cancelEdit() {                
      this.edited = false
    }
  }
</script>
<style>
.drag{
  display: flex;  
  height: 100%;
  align-items: center;  
}
</style>